import { FlashSaleTimerHeaderProps, Styled } from '.';
import { flashSaleColor } from 'components/FlashSaleTimerHeader/FlashSaleTimerHeader.helper';
import { useI18n } from 'contexts/i18n';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';

const ClockCountdown = ({ expiresAt }: FlashSaleTimerHeaderProps) => {
  const i18n = useI18n();

  return (
    <Styled.CountdownContainer>
      <FlipClockCountdown
        to={expiresAt}
        labels={[i18n['DAY'], i18n['HOUR'], i18n['MIN'], i18n['SEC']]}
        className="flip-clock"
        digitBlockStyle={{
          fontSize: 13,
          width: 20,
          height: 25,
          background: 'white',
          color: flashSaleColor,
        }}
        separatorStyle={{
          color: 'white',
          size: 3,
        }}
        labelStyle={{
          fontSize: 9,
          fontWeight: 500,
          textTransform: 'uppercase',
          color: 'white',
          marginBottom: 1,
        }}
        dividerStyle={{
          height: 0,
        }}
      />
    </Styled.CountdownContainer>
  );
};

export default ClockCountdown;
